import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { marketingProjectService } from 'services';

export const useCreateMarketingProject = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      projectId,
      projectName,
      sku,
      status,
    }: {
      projectId: string;
      projectName: string;
      sku: string;
      status: string;
    }) => {
      return marketingProjectService.createProject(
        projectId,
        projectName,
        sku,
        status
      );
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({
          queryKey: [ServerStateKeysEnum.marketingProjects],
        });
      },
      onError: () => {},
    }
  );
};
